import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import { config as axiosConfig } from "../../config/constants";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import SendIcon from "@material-ui/icons/Send";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import { deepOrange, purple, blue } from "@material-ui/core/colors";

import AuthenticationContext from "../../contexts/auth/Auth.context";
import { UPDATE_FOLLOW_DATA } from "../../contexts/types";
const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 500,
    margin: "20px auto",
    "& .MuiTextField-root": {
      width: "100%",
    },
    "& .MuiOutlinedInput-multiline": {
      paddingTop: "8px",
      paddingBottom: "8px",
      marginTop: "5px",
      marginLeft: "5px",
      marginRight: "5px",
    },
    "& .MuiCardContent-root:last-child": {
      paddingBottom: "10px",
    },
    "& .MuiDivider-middle": {
      marginBottom: "4px",
    },
    "& .MuiListItem-root": {
      padding: "0px 16px",
    },
    "& .MuiCardContent-root": {
      paddingTop: "0px",
      paddingBottom: "5px",
    },
    "& .MuiIconButton-root:focus": {
      backgroundColor: "rgba(0, 0, 0, 0)",
    },
  },
  header: {
    padding: "10px",
  },
  media: {
    //height: 0,
    paddingTop: "56.25%", // 16:9
    height: "max-content",
  },
  likeBar: {
    height: "25px",
    paddingTop: "0px",
    marginTop: "8px",
    marginLeft: "2px",
    paddingLeft: "0px",
    paddingBottom: "4px",
  },
  comments: {
    display: "flex",
    paddingTop: "0px",
    paddingLeft: "12px",
    paddingRight: "0px",
  },
  comment_item_see_more: {
    width: "35%",
    cursor: "pointer",
  },
  comments_icon_see_more: {
    height: "17px",
    width: "17px",
    paddingTop: "4px",
    paddingBottom: "3px",
  },
  comments_icon: {
    height: "30px",
    paddingLeft: "0px",
    paddingTop: "13px",
    paddingRight: "8px",
    paddingBottom: "0px",
  },
  inline: {
    display: "inline",
    fontWeight: "600",
  },
  avatar: {
    height: "40px",
  },
  links: {
    textDecoration: "none",
  },
}));

const AvatarsPalette = [deepOrange[500], purple[500], blue[500]];
const config = axiosConfig(localStorage.getItem("jwt"));
function PostCard(props) {
  const { item, likePost, unlikePost, makeComment, bookmark, removeBookmark } =
    props;
  const classes = useStyles();
  const { state, dispatch } = useContext(AuthenticationContext);
  const [avatarColor] = useState(
    AvatarsPalette[Math.floor(Math.random() * AvatarsPalette.length)]
  );
  const [isHovered, setIsHovered] = useState(false);
  const [showSend, setShowSend] = useState(false);
  const [showFollow, setShowFollow] = useState(
    !state?.user?.Following.includes(item?.PostedBy?._id)
  );
  const [comment, setComment] = useState("");

  const followUser = (id) => {
    axios
      .put(`http://localhost:5000/follow`, { followId: id }, config)
      .then((result) => {
        dispatch({
          type: UPDATE_FOLLOW_DATA,
          payload: {
            Followers: result.data.Followers,
            Following: result.data.Following,
          },
        });
        localStorage.setItem("user", JSON.stringify(result.data));

        setShowFollow(false);
      });
  };

  return (
    <Card
      className={classes.root}
      raised={isHovered}
      onMouseOver={() => setIsHovered(true)}
      onMouseOut={() => setIsHovered(false)}
    >
      <CardHeader
        className={classes.header}
        avatar={
          <Avatar
            src={`data:${item.PostedBy?.PhotoType};base64,${item.PostedBy?.Photo}`}
            style={{ backgroundColor: avatarColor }}
          >
            {item.PostedBy?.Name.split(" ")
              .map((n) => n.slice(0, 1).toUpperCase())
              .join("")}
          </Avatar>
        }
        title={
          <Box display="flex" alignItems="center" gridGap={10}>
            <Link
              className={classes.links}
              to={
                item.PostedBy._id !== state.user._id
                  ? `/profile/${item.PostedBy._id}`
                  : "/profile"
              }
            >
              {item.PostedBy.Name}
            </Link>
            {showFollow && (
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                startIcon={<PersonAddIcon fontSize="8px" />}
                onClick={() => followUser(item.PostedBy._id)}
                style={{ fontSize: "8px", paddingBlock: 5 }}
              >
                Follow
              </Button>
            )}
          </Box>
        }
        subheader={new Date(item.createdAt)?.toDateString()}
      />

      <CardMedia
        className={classes.media}
        image={`data:${item.PhotoType};base64,${item.Photo}`}
        title={item.title}
      />

      <CardActions className={classes.likeBar} disableSpacing>
        {item.Likes.includes(state.user._id) ? (
          <IconButton
            aria-label="Like"
            title="Unlike"
            color="secondary"
            onClick={() => {
              unlikePost(item._id);
            }}
          >
            <FavoriteIcon color="error" />
          </IconButton>
        ) : (
          <IconButton
            aria-label="Like"
            title="Like"
            onClick={() => {
              likePost(item._id);
            }}
          >
            <FavoriteBorderIcon />
          </IconButton>
        )}
        <IconButton aria-label="comments">
          <ChatBubbleOutlineIcon />
        </IconButton>
        {bookmark && removeBookmark ? (
          item.Bookmarks && item.Bookmarks.includes(item._id) ? (
            <IconButton
              aria-label="Remove Bookmark"
              style={{ marginLeft: "auto", color: "#e0d011" }}
              onClick={() => {
                removeBookmark(item._id);
              }}
            >
              <BookmarkIcon />
            </IconButton>
          ) : (
            <IconButton
              aria-label="Bookmark"
              style={{ marginLeft: "auto" }}
              onClick={() => {
                bookmark(item._id);
              }}
            >
              <BookmarkBorderIcon />
            </IconButton>
          )
        ) : null}
      </CardActions>

      <CardContent>
        <Typography variant="caption" display="block" gutterBottom>
          {item.Likes.length} Likes
        </Typography>
        <Typography variant="subtitle2" component="b">
          {item.Title}
        </Typography>
        <Typography variant="caption" color="textSecondary" component="p">
          {item.Body}
        </Typography>
      </CardContent>

      <Divider variant="middle" />

      <List>
        {item.Comments.map((cmt) => {
          return (
            <ListItem
              className={classes.comment_item}
              alignItems="flex-start"
              key={cmt._id}
            >
              <ListItemText
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      className={classes.inline}
                      color="textPrimary"
                    >
                      <Link
                        className={classes.links}
                        to={
                          cmt.PostedBy._id !== state.user._id
                            ? `/profile/${cmt.PostedBy._id}`
                            : "/profile"
                        }
                      >
                        {cmt.PostedBy.Name}
                      </Link>
                    </Typography>
                    {" — "}
                    {cmt.Text}
                  </React.Fragment>
                }
              />
            </ListItem>
          );
        })}
        {item.Comments.length === 0 ? (
          <ListItem alignItems="flex-start" style={{ left: "38%" }}>
            <Typography variant="caption" display="block" gutterBottom>
              No Comments yet
            </Typography>
          </ListItem>
        ) : null}
        {item.Comments.length > 3 && item.Comments.length !== 0 ? (
          <ListItem
            alignItems="flex-start"
            className={classes.comment_item_see_more}
          >
            <Typography variant="caption" display="block" gutterBottom>
              See all {item.Comments.length} comments
            </Typography>
            <DoubleArrowIcon className={classes.comments_icon_see_more} />
          </ListItem>
        ) : null}
      </List>

      <Divider variant="middle" />

      <CardContent className={classes.comments}>
        <Avatar>
          <img
            className={classes.avatar}
            alt=""
            src="https://images.unsplash.com/photo-1537815749002-de6a533c64db?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
          />
        </Avatar>
        <TextField
          multiline
          rows={1}
          placeholder="Add your comment..."
          variant="outlined"
          value={comment}
          onChange={(event) => {
            event.preventDefault();
            setComment(event.target.value);
            setShowSend(true);
            if (event.target.value === "") setShowSend(false);
          }}
        />
        <IconButton
          aria-label="add to favorites"
          className={classes.comments_icon}
          disabled={!showSend}
          onClick={() => makeComment(comment, item._id)}
        >
          <SendIcon />
        </IconButton>
      </CardContent>
    </Card>
  );
}

PostCard.propTypes = {
  item: PropTypes.object.isRequired,
  likePost: PropTypes.func.isRequired,
  unlikePost: PropTypes.func.isRequired,
  makeComment: PropTypes.func.isRequired,
  bookmark: PropTypes.func,
  removeBookmark: PropTypes.func,
};

export default PostCard;
